import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Experiential thinking</div>
                                            <p>When thinking laterally, put yourself in the situation you’re
                                                considering. Visualise yourself actually
                                                there, and visualise what you, and whoever else might be
                                                there, are doing. Try to involve as many
                                                of your senses as possible. What are you thinking, feeling,
                                                seeing, hearing, tasting and even
                                                smelling? You’ll be surprised by how much more information
                                                or inspiration this yields.</p>
                                            <div className="border_subtitle">Big picture vs. detailed
                                                thinking
                                            </div>
                                            <p>Sometimes, if we concentrate on detail, we ‘can’t see the
                                                wood for the trees’. In other words, while
                                                detail is important, we need to consider it in context to
                                                make our thinking practical and generate
                                                other, appropriate ideas. In example four on previous page,
                                                details of a car which ‘crashed’ and ‘sank to
                                                the bottom’ suggest tragedy. In fact, the driver – a bit
                                                surprised, perhaps, and no doubt a little cold
                                                and damp – was safe, sitting in his car on a shallow river’s
                                                bed!</p>
                                            <div className="border_subtitle">Pictorial thinking</div>
                                            <p>In the famous stories, Sherlock Holmes was a great one for
                                                visualising and sketching scenes of
                                                crime as imagined by him, or described by someone else. Try
                                                sketching what you think you would see
                                                if you were in the situation you’re contemplating, to reveal
                                                perspectives you might otherwise miss.</p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/>PREFERENCES</span></div>
                                            <p>Use the table below to identify your preferred, or usual way
                                                of thinking and help you consider
                                                others. Note down your preferences, 1-3. Put a 1, 2 or 3
                                                against the corresponding preference:</p>
                                            <div className="mobile-scroll select-dropdown"
                                                 style={{height:'auto'}}>
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport_new_task">
                                                    <tbody>
                                                    <tr>
                                                        <th align="left" width="25%">Preferences</th>
                                                        <th align="left" width="25%">1, 2 or 3</th>
                                                        <th align="left" width="25%">Preferences</th>
                                                        <th align="left" width="25%">1, 2 or 3</th>
                                                    </tr>
                                                    <tr>
                                                        <td>Bigger Picture</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="BiggerPicture"
                                                                    value={this.props.pageData?.BiggerPicture}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                        <td>Detail Focused</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="DetailFocused"
                                                                    value={this.props.pageData?.DetailFocused}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr className="lgtgreenbg">
                                                        <td>Creative</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Creative"
                                                                    value={this.props.pageData?.Creative}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                        <td>Literal</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Literal"
                                                                    value={this.props.pageData?.Literal}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Logical</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Logical"
                                                                    value={this.props.pageData?.Logical}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                        <td>Intuitive</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Intuitive"
                                                                    value={this.props.pageData?.Intuitive}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr className="lgtgreenbg">
                                                        <td>Experiential</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Experiential"
                                                                    value={this.props.pageData?.Experiential}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                        <td>Observational*</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Observational"
                                                                    value={this.props.pageData?.Observational}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pictoral</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Pictoral"
                                                                    value={this.props.pageData?.Pictoral}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                        <td>Aural**</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Aural"
                                                                    value={this.props.pageData?.Aural}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr className="lgtgreenbg">
                                                        <td>Challenging</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Challenging"
                                                                    value={this.props.pageData?.Challenging}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                        <td>Accepting***</td>
                                                        <td align="left">
                                                            <span className="ilead-slect-box select">
                                                                <select
                                                                    style={{width:'98%'}}
                                                                    className="custom-dropdown"
                                                                    name="Accepting"
                                                                    value={this.props.pageData?.Accepting}
                                                                    onChange={this.props.handleChangePageData}>

                                                                    <option value="0">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                </select>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr></tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="uiheading"><p className="subText">*Observational
                                                is the opposite of experiential, so someone who takes a step
                                                back from a situation.</p></div>
                                            <div className="uiheading"><p className="subText">**Aural is
                                                someone who tends to use their hearing or listening to
                                                attend to a situation.</p></div>
                                            <div className=""><p className="subText">***Accepting is the
                                                opposite of challenging and is someone who accepts the
                                                status quo.</p></div>
                                            <p>Now consider this scenario<a className="superscripttext"
                                                                            href="further_info.php?course=300"><sup>4</sup></a> and
                                                put your answer in the box on the following page:</p>
                                            <div className="border_subtitle">Preference scenario</div>
                                            <div className="paraspace"><p>Two strangers from different parts
                                                of the UK build similar apartment buildings in their home
                                                towns. By chance, they both forget an item which is
                                                important to their project. They each, once
                                                again by chance, call the same national hardware store and
                                                order the missing items. The prices
                                                they are quoted are as follows:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>One will cost them £2</p></li>
                                                <li><p>Two will cost them £2</p></li>
                                                <li><p>Twelve will cost them £4</p></li>
                                                <li><p>One hundred and forty-four will cost £6.</p></li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}